<template>
  <div class="content pr-2">
    <h1 class="has-text-centered">
      AHL Corporate Event Services
    </h1>
    <hr>
    <strong>
      If you are looking for a way to add some fun to your next corporate event, Christmas party, private party etc. then AHL Poker has you covered!
    </strong>
    <p>
      AHL offers Full Service Poker & Casino Parties for up to 1000 people! These events are a great way to add some fun and excitement to any party!
    </p>
    <p>
      We offer custom packages to suit any budget.
    </p>
    <h3 class="title is-3">
      Services Include:
    </h3>
    <ul>
      <li>Professional uniformed tournament director</li>
      <li>All equipment needed to host your event</li>
      <li>Set up and break down of event</li>
      <li>Dealers for every table (optional)</li>
      <li>Trained dealers (optional)</li>
      <li>High resolution photos of your event in multiple formats (optional)</li>
      <li>Black Jack (optional)</li>
      <li>Price match guarantee!</li>
    </ul>
    <p>
      For more information or to book your event please contact us at <br>
      <a href="mailto:sales@ahlpoker.com">sales@ahlpoker.com</a>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'Events',
    metaInfo: {
      title: 'AHL Poker :: Services'
    },
    data () {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>